import Control from '../../1. Core/Control';
import DataTable from '../../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../../1. Core/Delegate';
import NP from '../../1. Core/NP';
import {ServerAPI} from '../../1. Core/ServerAPI';
import SiteUfcRankingsBoardPanel, {SiteRankingBoard} from './SiteUfcRankingsBoardPanel';

interface BoardRow extends SiteRankingBoard {
	kindLabel: string;
	limitLabel: string;
}

export default class SiteUfcRankingsList extends Control {
	private _topAppBar: TopAppBar;
	private EvShowPageModeClick: Delegate;
	private _dataTable: DataTable;
	private _boards: SiteRankingBoard[] = [];
	private _rootNode: HTMLElement;
	private _drillDownPanel: SiteUfcRankingsBoardPanel;

	constructor(settings: object) {
		super(settings);
		this._render();
	}

	_initFields(settings: object) {
		this.EvShowPageModeClick = new Delegate();
		super._initFields(settings);
	}

	getTopAppBar() {
		if (this._drillDownPanel) {
			return this._drillDownPanel.getTopAppBar();
		}
		return this._topAppBar;
	}

	_render() {
		this.np_render();
		this._rootNode = NP.createNode(this._root);

		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: 'Rankings',
			ParentNode: this._rootNode,
			ShowSearchButton: false,
			MainButton: {
				FontImage: NP.FontImages.menu,
				EvClick: () => this.EvShowPageModeClick.fire(this),
			},
		});

		this._dataTable = new DataTable({
			ParentNode: this._rootNode,
			ShowSettingsButton: false,
			Class: 'mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: false,
			EnableSort: false,
			Columns: [
				{Content: 'Board', PropertyContent: 'titleEn', Width: '42%'},
				{Content: 'Type', PropertyContent: 'kindLabel', Width: '18%'},
				{Content: 'Fighters', PropertyContent: 'entryCount', Width: '12%'},
				{Content: 'Limit', PropertyContent: 'limitLabel', Width: '12%'},
				{Content: 'Slug', PropertyContent: 'slug', Width: '16%'},
			],
			ShowPaginator: false,
			EvItemClick: (s: object, e: { Item: BoardRow }) => {
				this.showBoardPanel(e.Item);
			},
		});

		this.refresh();
	}

	kindLabel(kind: string): string {
		if (kind === 'champions') {
			return 'Champions';
		}
		if (kind.startsWith('pfp_')) {
			return 'P4P';
		}
		if (kind === 'division') {
			return 'Division';
		}
		return kind;
	}

	limitLabel(board: SiteRankingBoard): string {
		if (board.maxEntries == null) {
			return '—';
		}
		return String(board.maxEntries);
	}

	async refresh() {
		this._boards = await ServerAPI.get<SiteRankingBoard[]>('/site/rankings/boards');
		const rows: BoardRow[] = this._boards.map(b => ({
			...b,
			kindLabel: this.kindLabel(b.kind),
			limitLabel: this.limitLabel(b),
		}));
		this._dataTable.setRows(rows);
	}

	showBoardPanel(board: SiteRankingBoard) {
		NP.hideNode(this._rootNode);
		this._drillDownPanel = new SiteUfcRankingsBoardPanel({
			ParentNode: this._root,
			Width: this._Width,
			Height: this._Height,
			Board: {...board},
			EvBackClick: () => {
				NP.showNode(this._rootNode);
				this._drillDownPanel.destroy();
				this._drillDownPanel = null;
				this.refresh();
			},
		});
	}
}
